import { Price, Quantity } from '@cronos-app/components';
import { currentWallet } from '@cronos-app/wallet';
import { InputCard } from '@ui/components/Input/InputCard';
import { InputChips } from '@ui/components/Input/InputChips';
import { useTokenBalance } from '@ui/hooks/erc20/useTokenBalance';
import { validateNotEmpty } from '@ui/utils/validations';
import { useCardSupportedTokens } from '@ui/views/card-cronos/core/configs';
import {
  useCardContextStore,
  useCardLayer,
} from '@ui/views/card-cronos/core/useCardContextStore';
import {
  useMaxValue,
  useTokenUsdPriceByService,
  useUpdateDepositAmountInputError,
} from '@ui/views/card-cronos/core/utils';
import { Fraction } from 'bi-fraction';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';

import { TokenSelectModal } from '../TokenSelectModal';
import { TokenSelector } from '../TokenSelectModal/TokenSelector';
import { useTokenSelectModal } from '../TokenSelectModal/useTokenSelectModal';

export const TopUpInput = () => {
  const t = useTranslations();
  const { amount: amountStr, token, inputError } = useCardContextStore();
  const amount = useMemo(() => {
    try {
      return new Fraction(amountStr);
    } catch (err) {
      return Fraction.ZERO;
    }
  }, [amountStr]);
  const fromTokens = useCardSupportedTokens();
  const fromTokenPrice = useTokenUsdPriceByService(token);
  const account = currentWallet.useAccount();
  const { data: balance } = useTokenBalance({
    tokenAddress: token.address,
    account,
    chainLayer: useCardLayer(),
  });
  const maxValue = useMaxValue(balance);
  useUpdateDepositAmountInputError(token.decimals, amountStr, balance);
  return (
    <>
      <InputCard
        flex="1"
        value={amountStr}
        error={
          validateNotEmpty({
            t,
            value: amountStr,
          })
            ? null
            : inputError
        }
        balance={
          <Quantity
            value={balance?.toFixed(token.decimals)}
            format={{
              max: token.decimals,
            }}
            textStyle="caption"
          />
        }
        usd={
          <Price
            value={amount.toFixed(token.decimals)}
            price={fromTokenPrice?.toFixed(6)}
            textStyle="caption"
          />
        }
        inputChips={
          <InputChips
            value={amountStr}
            maxValue={maxValue}
            decimalPlaces={token.decimals}
            onChange={(value) => {
              useCardContextStore.getState().setAmount(value);
            }}
          />
        }
        tokenSelector={
          <TokenSelector
            token={token}
            onClick={() => {
              useTokenSelectModal.getState().openModal({
                tokens: fromTokens,
                onSelectToken: useCardContextStore.getState().setToken,
              });
            }}
          />
        }
        onChange={(e) =>
          useCardContextStore.getState().setAmount(e.target.value)
        }
      />
      <TokenSelectModal />
    </>
  );
};
